// DropdownSelect.js
import React, { useEffect, useRef, useState } from "react";
import { BlackChevronDown } from "../../../public/Theme";

const DropdownSelect = ({
    options,
    selected,
    onSelect,
    placeholder = "Select...",
    width = "",
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);

    // Toggle dropdown visibility
    const toggleDropdown = () => setIsOpen(!isOpen);

    // Close dropdown if clicking outside of the component
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                selectRef.current &&
                !selectRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className={`relative text-[13px] ${width} `} ref={selectRef}>
            <button
                onClick={toggleDropdown}
                className={`w-full px-3 py-2 text-left bg-white text-[#666666] border border-BORDER_GRAY rounded-sm shadow-sm flex gap-3 justify-between items-center
          focus:outline-none `}
            >
                <span className="text-[#666666] font-Poppins text-[13px] font-light">
                    {selected
                        ? selected?.label || selected?.title
                        : placeholder}
                </span>
                <span className="ml-2 bg-[#ECE9EE] rounded-full w-4 h-4 flex justify-center items-center shadow">
                    <img
                        alt="arrow"
                        className="w-3 h-3"
                        src={BlackChevronDown}
                    />
                </span>
                {/* Downward arrow icon */}
            </button>

            {isOpen && (
                <ul className="absolute w-full mt-1 bg-white border border-BORDER_GRAY rounded shadow-lg z-10">
                    {options.map((option, index) => (
                        <li
                            key={(option?.value || option?.slug) + index}
                            onClick={() => {
                                onSelect(option);
                                setIsOpen(false);
                            }}
                            className={`pl-1 py-2 text-black hover:bg-black hover:text-white font-Poppins ${(selected?.value || selected?.title) ===
                                (option?.value || option?.title)
                                ? "!bg-black !text-white"
                                : ""
                                } cursor-pointer !font-light`}
                        >
                            {option?.label || option?.title}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default DropdownSelect;
